module.exports = __webpack_public_path__ + "media/images/flags/64/Vanuatu-c43ded89bbb11f877ba18f3d6030a4f3.png";